// eslint-disable-next-line import/prefer-default-export
export const getIntercomState = (state) => state.intercom;
